import { useEffect, useState } from "react";
import axios from "axios";
import { Building2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { API } from "@/context/AuthContext";

export const CompanyHeaderDialog = ({ testPrefix }) => {
  const [open, setOpen] = useState(false);
  const [p, setP] = useState(null);
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!open) return;
    axios.get(`${API}/company-profile`).then((r) => { setP(r.data); setEmail(r.data.email || ""); }).catch(() => toast.error("Could not load header details"));
  }, [open]);
  const save = async () => {
    setBusy(true);
    try {
      const r = await axios.put(`${API}/company-profile`, { email });
      setP(r.data); toast.success("Statement header updated"); setOpen(false);
    } catch (e) { toast.error(e.response?.data?.detail || "Could not save"); } finally { setBusy(false); }
  };
  return (
    <>
      <Button variant="outline" size="sm" onClick={() => setOpen(true)} data-testid={`${testPrefix}-company-header-open`}><Building2 className="h-4 w-4 mr-1.5" />Statement header</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md" data-testid={`${testPrefix}-company-header-dialog`}>
          <DialogHeader><DialogTitle>Vendor statement header</DialogTitle></DialogHeader>
          {p && (
            <div className="space-y-1 text-sm text-slate-700" data-testid={`${testPrefix}-company-header-info`}>
              <p className="font-semibold">{p.name}</p>
              <p className="text-xs text-slate-500">{p.address}</p>
              <p className="text-xs">GST: <b data-testid={`${testPrefix}-company-gstin`}>{p.gstin || "—"}</b> · PAN: <b>{p.pan || "—"}</b> · State: {p.state}</p>
              <p className="text-[11px] text-slate-400">GST and PAN are read from SAP.</p>
            </div>
          )}
          <div>
            <p className="text-xs text-slate-600 mb-1">Email ID shown on the statement</p>
            <Input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="accounts@ydgroup.com" data-testid={`${testPrefix}-company-email`} />
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)} data-testid={`${testPrefix}-company-header-cancel`}>Cancel</Button>
            <Button onClick={save} disabled={busy} className="bg-slate-900 text-white hover:bg-slate-800" data-testid={`${testPrefix}-company-header-save`}>Save</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
